var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('q-and-a-content',{attrs:{"title":'グループ内イベントの確認'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          イベント画面にて開催中または今後開催されるイベントを閲覧することができます。イベントを·タップし、参加者のスコアやイベントのルールなどの情報を確認できます。")]),_vm._v(" "),_c('img',{staticClass:"picture",attrs:{"src":require("../assets/images/q_and_a/17.png")}})])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f899cb96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FeaturesActivity.vue
// module id = 3qO/
// module chunks = 0